const DAISY_ENV = {
  DAISY_API_URL () {
    return process.env.VUE_APP_DAISY_API
  },
  DAISY_IMAGES_URL () {
    return process.env.VUE_APP_DAISY_IMAGES_URL
  }
}

export default DAISY_ENV
